import { __awaiter } from "tslib";
/* tslint:disable */
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from '@souche-f2e/muji';
import Root, { router } from './Root';
import store from './store';
import { createRouterPlugin } from '@souche-f2e/muji';
import bootstrap from '/home/souche/jenkins/workspace/TAG_AuctionSass_auctionsass-muji/src/bootstrap';
import createLoadingPlugin from '@souche-f2e/muji-plugin-loading/createLoadingPlugin';
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    store.use(createRouterPlugin(router));
    store.use(createLoadingPlugin());
    store.init();
    if (typeof bootstrap === 'function') {
        yield bootstrap({ router });
    }
    router.init();
    store.triggerSetupFns();
});
const App = () => (<Provider store={store}>
    <Root />
  </Provider>);
const render = () => {
    ReactDOM.render(<App />, document.getElementById('root'));
};
init()
    .then(() => {
    render();
})
    .catch((err) => {
    if (process.env.NODE_ENV === 'development') {
        console.error(err);
    }
});
